import { useContext, useEffect } from "react";
import { AppContext } from "../Context/Context";

const useModalClose = (wrapperId, onClose) => {
  const { alertObject } = useContext(AppContext);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (e.target.id === wrapperId) {
        onClose();
      }
    };

    const handleEscKey = (e) => {
      if (e.key === "Escape") {
        if (alertObject?.type?.length) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        onClose();
      }
    };

    document.addEventListener("click", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [wrapperId, onClose, alertObject]);
};

export default useModalClose;
